import config from "@Config/index";

type LocationWithCountry = {
  country?: {
    short_name?: string;
    long_name?: string;
  };
};

export const isUkLocation = (location?: LocationWithCountry | null): boolean => {
  const shortName = location?.country?.short_name?.toUpperCase();
  const longName = location?.country?.long_name?.toLowerCase();
  return shortName === "GB" || longName === "united kingdom";
};

export const shouldShowSlashedPricing = ({
  growthBookEnabled,
  location,
  providerId,
}: {
  growthBookEnabled: boolean;
  location?: LocationWithCountry | null;
  providerId?: number | null;
}): boolean => {
  if (providerId === 49) return false;

  if (config.IS_CHINA_APP) {
    return isUkLocation(location);
  }

  return growthBookEnabled;
};
